// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_FROM_LINKEDIN = false;
